<template>
  <div>
    <JadeBox hasPadding>
      <div class="validation__img--container">
        <img :src="require(`@/assets/kyc/step_1.svg`).default" />
      </div>
      <div class="validation__text--container">
        <jade-text
          weight="bold"
          variant="heading-small"
        >
          {{ $t('title') }}
        </jade-text>
        <jade-text variant="text-medium">
          {{ $t('subtitle') }}
        </jade-text>
      </div>

      <div class="validation__date--container">
        <jade-icon
          use="action-refresh"
          size="medium"
          color="brand"
        />
        <jade-text
          variant="text-medium"
          color="brand"
        >
          {{ $t('updated_at', { date, time }) }}
        </jade-text>
      </div>
    </JadeBox>
  </div>
</template>
<script>
import JadeBox from '@jade/JadeBox/index.vue'
import JadeText from '@jade/JadeText/index.vue'
import JadeIcon from '@jade/JadeIcon/index.vue'

export default {
  name: 'Validation',
  components: {
    JadeBox,
    JadeText,
    JadeIcon
  },
  props: {
    date: {
      type: String,
      required: true
    },
    time: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';

.validation__img--container,
.validation__text--container,
.validation__date--container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.validation__img--container {
  padding-bottom: var(--global-space-400, 32px);
}
.validation__text--container {
  flex-direction: column;
  text-align: center;
  gap: var(--global-space-200, 16px);
  padding-bottom: var(--global-space-200, 16px);
}
.validation__date--container {
  gap: var(--global-space-100, 8px);
}
</style>

<i18n>
  {
    "pt-BR": {
      "title": "Estamos analisando suas informações",
      "subtitle": "Agora é só aguardar. Em algumas horas o resultado da análise vai estar disponível.",
      "updated_at": "Atualizado em {date} ás {time}"
    },
    "en-US": {
      "title": "We are analyzing your information",
      "subtitle": "Now just wait. In a few hours the results of the analysis will be available.",
      "updated_at": "Updated on {date} ata {time}"
    }
  }
  </i18n>
